module.exports = __webpack_public_path__ + "static/media/btn-section-expand.b3752683.svg";